import React, { useState } from "react";

const UploadFolder = () => {
  const [filePaths, setFilePaths] = useState([]);

  const handleFolderUpload = (event) => {
    const files = event.target.files;
    const paths = [];
    console.log("files:", files)
    for (let i = 0; i < files.length; i++) {
      paths.push(files[i].webkitRelativePath);
    }

    setFilePaths(paths);
  };
  return (
    <div>
      <input 
        type="file"
        onChange={handleFolderUpload}
        {...{ webkitdirectory: "true" } as any}
      />
      
      {filePaths.length > 0 && (
        <div>
          <h3>File Paths:</h3>
          <ul>
            {filePaths.map((path, index) => (
              <li key={index}>{path}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default UploadFolder;
